/** In-memory cache + in-flight dedup for criminal wizard master-data APIs. */

const dataCache = new Map<string, unknown>();
const inflight = new Map<string, Promise<unknown>>();

export async function cachedCriminalFetch<T>(
  key: string,
  fetcher: () => Promise<T>,
  options?: { cacheWhen?: (result: T) => boolean },
): Promise<T> {
  if (dataCache.has(key)) {
    return dataCache.get(key) as T;
  }

  const pending = inflight.get(key);
  if (pending) {
    return pending as Promise<T>;
  }

  const shouldCache = options?.cacheWhen ?? (() => true);

  const promise = fetcher()
    .then((result) => {
      if (shouldCache(result)) {
        dataCache.set(key, result);
      }
      inflight.delete(key);
      return result;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });

  inflight.set(key, promise);
  return promise as Promise<T>;
}

export function hasCachedCriminalFetch(key: string): boolean {
  return dataCache.has(key);
}

export function clearCriminalLookupCache(): void {
  dataCache.clear();
  inflight.clear();
}
